<template>
  <div class="deviceParamsItem">
    <div class="title">
      <h4>{{ dataObj.title || "参数" }}</h4>
    </div>
    <div class="content">
      <DataPagination
        v-if="dataObj?.content?.length > 4"
        :listData="dealData(dataObj.content)"
        className="deviceParamsDataSwitch"
        :classNameTitleTipsItem="
          dataObj?.twoLine
            ? 'deviceParamsTitleTipsItemTwoLine'
            : 'deviceParamsTitleTipsItem'
        "
        :splitNum="1"
        :showName="false"
        combineNameUnit
        smallPagination
      />
      <el-empty
        v-else-if="dataObj?.content?.length < 1"
        class="empty"
        :image-size="80"
        description="暂无数据"
      ></el-empty>
      <TitleTipsItem
        v-else
        :listData="dataObj?.content || []"
        :modalFlag="1"
        combineNameUnit
        :className="
          dataObj?.twoLine
            ? 'deviceParamsTitleTipsItemTwoLine'
            : 'deviceParamsTitleTipsItem'
        "
      />
    </div>
  </div>
</template>
<script>
import TitleTipsItem from "@/components/TitleTips/TitleTipsItem.vue";
import DataPagination from "@/components/zixitong/airSystem/DataPagination.vue";
export default {
  components: { TitleTipsItem, DataPagination },
  name: "DeviceParamsItem",
  props: {
    dataObj: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {};
  },
  methods: {
    //将4个value组成一组
    dealData(data) {
      const newData = [];
      let obj = { name: 1, value: [] };
      Array.isArray(data) &&
        data.forEach((element, index) => {
          obj.value.push(element);
          if (index % 4 == 3 || index === data.length - 1) {
            newData.push(obj);
            obj = { name: index, value: [] };
          }
        });
      return newData;
    },
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.deviceParamsItem {
  width: 236px;
  height: 100%;
  border-radius: 8px;
  border: 2px solid #f4f6f7;

  .title {
    @include setFlexBetween;
    height: 32px;
    background-color: #f8fafb;

    h4 {
      font-size: 14px;
      margin: 0 0 0 20px;
      text-indent: 10px;
      color: #666;
      border-left: none;
    }
  }

  .content {
    height: calc(100% - 45px);
    width: 100%;

    ::v-deep .deviceParamsDataSwitch {
      margin: 8px;
      height: 180px;

      & > div {
        width: calc(100% - 16px);
      }
    }

    ::v-deep .deviceParamsTitleTipsItem {
      flex-wrap: wrap;
      margin: 8px;
      height: 100%;

      & > div {
        width: 220px;
        max-width: none;
        height: 30px;
        display: flex;
        justify-content: flex-start;
        margin-left: 8px;

        .itemName {
          width: 120px;
          max-width: none;
        }

        .itemValue {
          font-size: 16px;
          max-width: 100px;
          margin-left: 10px;
        }
      }
    }

    ::v-deep .deviceParamsTitleTipsItemTwoLine {
      flex-wrap: wrap;
      margin: 8px;
      height: 100%;

      & > div {
        width: 220px;
        max-width: none;
        height: 100%;
        display: flex;
        margin-left: 8px;
        flex-direction: column;
        align-items: flex-start;
        justify-content: space-evenly;

        .itemName {
          width: 140px;
          max-width: none;
        }

        .itemValue {
          font-size: 16px;
          max-width: 200px;
          margin-left: 10px;
          margin-top: 8px;
        }
      }
    }
  }
}
</style>
